import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import SidebarSpotlightIcon from 'components/layout/buttons/SideBarSpotlightIcon';
import translations from 'services/translations/translations';
import { Tooltip } from 'reactstrap';

const SpotlightIcon = ({ settings }: { settings: any }): JSX.Element => {
  const { t } = useTranslation([translations.leftBar]);
  const [tooltipIsOpen, setTooltipIsOpen] = useState(false);

  const turnOnLights = (camera: any) => {
    if (window.allSpotlights.length <= 80) {
      window.allSpotlights.forEach((item: any) => {
        item.visible = true;
      });

      return;
    }

    window.allSpotlights.forEach((item: any) => {
      if (item.position.distanceTo(camera.position) > 10000) {
        if (item.visible) {
          item.visible = false;
        }
      } else if (!item.visible) {
        item.visible = true;
      }
    });
  };

  const id = 'left-bar-spotlight-icon';

  return (
    <>
      <SidebarSpotlightIcon
        className="left-bar-icon"
        id={id}
        onClick={() => turnOnLights(settings.camera)}
      />
      <Tooltip
        id={id}
        isOpen={tooltipIsOpen}
        placement="right"
        target={id}
        toggle={() => setTooltipIsOpen(!tooltipIsOpen)}
      >
        {t(`${translations.leftBar}:tooltips:Toggle spotlight`)}
      </Tooltip>
    </>
  );
};

export default SpotlightIcon;
